<template>
  <div>
    <div class="row row-sm">
      <div class="col-12 col-md-6 col-lg-3 col-xl-3">
        <label for=""> Client </label>

        <vue-select
          :options="customers"
          v-model="filter.customer_reference"
          placeholder="Select an option"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-12 col-md-6 col-lg-3 col-xl-3">
        <label for=""> Société (vente) </label>

        <vue-select
          :options="societies"
          v-model="filter.society_reference"
          placeholder="Toutes"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl col-12">
        <label for="itemInput">Produit</label>

        <vue-select
          :options="items"
          v-model="filter.item_reference"
          placeholder="Select an option"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-12 col-md-6 col-lg col-xl">
        <label for="">
          {{ $t("sale8") }} <span class="text-danger">*</span>
        </label>
        <input v-model="filter.startDate" type="date" class="form-control" />
      </div>
      <div class="col-12 col-md-6 col-lg col-xl">
        <label for="">
          {{ $t("sale9") }} <span class="text-danger">*</span>
        </label>
        <input v-model="filter.endDate" type="date" class="form-control" />
      </div>

      <div class="col-12 col-md-6 col-lg-2 col-xl-2">
        <label for=""> {{ $t("sale10") }} </label>
        <select v-model="filter.paymentStatus" class="form-select">
          <option value="--">--</option>
          <option value="paid">Payé</option>
          <option value="Unpaid">Impayé</option>
        </select>
      </div>
    </div>
    <br />
    <div class="row justify-content-end">
      <!-- Bouton Filtrer -->
      <div class="col-12 col-md-6 col-lg-auto col-xl-auto">
        <button @click="toFilter(filter)" class="btn btn-secondary">
          <i class="bi bi-funnel-fill me-1"></i>
          {{ $t("sale11") }}
        </button>
      </div>

      <!-- Bouton Actualiser -->
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise me-1"></i>
          Actualiser
        </button>
      </div>

      <!-- Bouton Export (Excel) -->
      <div class="col-auto">
        <button @click="exportInvoices(filter)" class="btn btn-success">
          <i class="bi bi-file-earmark-excel-fill me-1"></i>
          Export Excel
        </button>
      </div>
    </div>

    <br />
    <vue-data-table
      :headers="headers"
      :data="invoices"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
    >
      <template #cell-amountPaid="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.amountPaid > 0 && row.amountPaid == row.totalPriceTTC
              ? 'bg-light-success text-success'
              : row.amountPaid > 0 && row.amountPaid < row.totalPriceTTC
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.amountPaid > 0 ? row.amountPaid : " Impayé " }}
        </span>
      </template>

      <template #cell-passPermit="{ row }">
        <span class="px-2 py-1 rounded">
          {{ row.passPermit ? "LP" + row.passPermit : "-" }}
        </span>
      </template>

      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded bg-light-primary">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-paymentMethod="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.amountPaid > 0 && row.amountPaid == row.totalPriceTTC
              ? 'bg-light-success text-success'
              : row.amountPaid > 0 && row.amountPaid < row.totalPriceTTC
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.amountPaid > 0 ? row.paymentMethod : " Impayé " }}
        </span>
      </template>

      <template #cell-date="{ row }">
        <span class="px-2 py-1 rounded">
          {{ formatDate(row.date) }}
        </span>
      </template>

      <template #cell-saleDate="{ row }">
        <span class="px-2 py-1 rounded">
          <span
            v-if="formatDate(row.date) !== formatDate(row.saleDate)"
            class="px-2 py-1 rounded bg-light-warning text-danger"
          >
            <i class="bi bi-exclamation-triangle"></i>
            {{ formatDate(row.saleDate) }}
          </span>
          <span v-else class="text-muted"> </span>
        </span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  computed: {
    ...mapGetters("invoice", {
      invoices: "getInvoices",
    }),
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("society", {
      societies: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("item/getAll");
    this.$store.dispatch("customer/getAll");
    this.$store.dispatch("society/getAll");
    // this.$store.dispatch("invoice/getAll");
    // // Set French locale for Moment if needed
    // moment.locale('fr');
    if (
      this.$route.query.item_reference ||
      this.$route.query.customer_reference ||
      this.$route.query.society_reference ||
      this.$route.query.startDate ||
      this.$route.query.endDate
    ) {
      const filterData = {
        item_reference: this.$route.query.item_reference || null,
        customer_reference: this.$route.query.customer_reference || null,
        society_reference: this.$route.query.society_reference || null,
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
      };
      this.filter = filterData;
      this.toFilter(filterData);
    } else {
      this.$store.dispatch("invoice/getAll");
    }
  },
  data() {
    return {
      filter: {
        customer_reference: "",
        society_reference: "",
        item_reference: "",
        startDate: "",
        endDate: "",
        paymentStatus: "",
      },
      headers: [
        { field: "reference", label: "Nº", class: "" },
        { field: "customerFullName", label: "Client", class: "" },
        { field: "societyFullName", label: "Société", class: "" },
        { field: "sale_reference", label: "BL", class: "" },
        { field: "order_reference", label: "BC", class: "" },
        { field: "passPermit", label: "LP", class: "" },
        { field: "totalPriceTTC", label: "Montant", class: "fw-bold" },
        { field: "amountPaid", label: "Paye", class: "fw-bold" },
        { field: "amountUnpaid", label: "Impaye", class: "fw-bold" },
        { field: "paymentMethod", label: "Regelement", class: "fw-bold" },
        { field: "date", label: "Date", class: "" },
        { field: "saleDate", label: "", class: "" },
        { field: "remark", label: "NB", class: "" },
        { field: "userFullName", label: "Creer par", class: "" },
      ],

      buttons: [
        {
          label: "Imprimer",
          icon: "bi bi-printer",
          class: "btn btn-secondary",
          action: (invoice) => this.printInvoice(invoice.reference),
        },

        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-danger",
          action: (invoice) => this.remove(invoice.reference),
          condition: () => this.$userRole === "Admin",
        },
      ],
      summableColumns: [{ field: "totalPriceTTC", class: "fw-bold" }],
    };
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("DD-MM-YYYY") : "-";
    },
    async refresh() {
      await this.$store.dispatch("invoice/getAll");
      await this.$router.push({
        name: "invoices-index",
      });
    },
    async printInvoice(reference) {
      await this.$store.dispatch("invoice/print", reference);
    },
    async remove(reference) {
      this.$store.dispatch("invoice/destroy", reference);
    },
    async exportInvoices(data) {
      await this.$store.dispatch("invoice/exportInvoices", data);
      await this.$router.push({
        name: "invoices-index",
        query: {
          item_reference: data.item_reference,
          customer_reference: data.customer_reference,
          society_reference: data.society_reference,
          startDate: data.startDate,
          endDate: data.endDate,
        },
      });
    },
    async toFilter(data) {
      await this.$store.dispatch("invoice/filter", data);
      await this.$router.push({
        name: "invoices-index",
        query: {
          item_reference: data.item_reference,
          customer_reference: data.customer_reference,
          society_reference: data.society_reference,
          startDate: data.startDate,
          endDate: data.endDate,
        },
      });
    },
  },
};
</script>
